import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { APIServices } from '../config/app-config';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppService } from '../modules/shared/app-service/app-service.service';


@Injectable()
export class BeforeNavigationHome implements CanActivate {

  constructor(private router: Router, private http: HttpClient, public appService: AppService) {
  }

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {

    let promise = new Promise<boolean>((resolve, reject) => {
      if (this.appService.navigationUrl && this.appService.navigationUrl != '/' && this.appService.isLogged) {
        this.router.navigate([this.appService.navigationUrl]);
        this.appService.navigationUrl = null;
        this.appService.setLoadingFalse();
        resolve(false);
      } else {
        resolve(true);
      }
    });

    return promise;

  }

}
